// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"i0-z","sponsoredTooltipWrapper":"j0-z","sponsoredTooltip":"k0-z","newCard":"l0-z"};